import { ComponentIds, DynamicRangeUtils, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerEcsSystem, ProductType, InfoActionTargetComponent } from '@inter-ikea-storageone/range';
import { UPRIGHT_TO_MOUNTING_RAIL_LEFT } from '@inter-ikea-storagetwo/boaxel/dist/constants/connectorKeys';
import { COMPONENT_IDS } from '@inter-ikea-storagetwo/range';
import { CONNECTOR_TO_SIZE_MAP } from '../utils/connectorUtils';
const { MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID, META_DATA_COMPONENT_ID, COMMUNICATION_SIZE_COMPONENT_ID } = ComponentIds;
/**
 * Adds InfoActionTargetComponent to NonMountingRail entity.
 * Used to display the correct details when clicking the info button in the context menu.
 */
export class NonMountingRailInfoSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'NonMountingRailInfoSystem', MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
        this.mandatoryComponents = [COMPONENT_IDS.UPRIGHT_COMPONENT];
    }
    onAdd(entity, newComponent) {
        const { hostConnector } = newComponent.snap;
        if (hostConnector.key === UPRIGHT_TO_MOUNTING_RAIL_LEFT)
            return;
        const color = entity.getComponent(META_DATA_COMPONENT_ID)?.metaData.design;
        const height = entity.getComponent(COMMUNICATION_SIZE_COMPONENT_ID)
            ?.size.height;
        const mountingRail = HierarchyUtils.parent(entity);
        const sections = this.coreApi
            .getRangeProducts()
            .filter(p => p.type === ProductType.BOAXEL_UPRIGHT_SECTION);
        const newWidth = CONNECTOR_TO_SIZE_MAP.get(hostConnector.key);
        const matchingSection = sections.find(section => {
            const widthMatches = section.template.comSize.width === newWidth;
            const heightMatches = section.template.comSize.height === height;
            const sectionColor = DynamicRangeUtils.getMeta(section)?.design;
            const colorMatches = sectionColor === color;
            return widthMatches && heightMatches && colorMatches;
        });
        if (mountingRail?.hasComponent(InfoActionTargetComponent.id))
            mountingRail.removeComponent(InfoActionTargetComponent.id);
        matchingSection &&
            mountingRail?.addComponent(new InfoActionTargetComponent(matchingSection.id));
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=NonMountingRailInfoSystem.js.map